<div class="photo-selector-container">
  <button *ngIf="showBackButton" class="back-btn" (click)="backButtonCallback && backButtonCallback()">
    <i class="fa fa-arrow-left"></i>
  </button>

  <!-- Curated images container -->
  <div class="curated-images-container">
    <div class="upload-custom-row">
      <div class="curated-image-item upload-custom-btn" [attr.data-tutorial-target]="tutorialTargetPrefix + '-upload-custom'"
        [class.selected]="iconFileUploadComplete" (click)="triggerFileInput()">
        <div class="upload-icon">
          <i class="fa fa-upload"></i>
        </div>
      </div>
    </div>

    <div class="curated-icons-focus-region" [attr.data-tutorial-target]="tutorialTargetPrefix + '-curated-icons'">
      <div class="curated-icons-grid">
        <!-- Curated images selection -->
        <div *ngFor="let image of curatedImages; trackBy: trackByImageUrl"
          class="curated-image-item"
          [class.selected]="selectedCuratedImageUrl === image.url && !iconFileUploadComplete"
          (click)="selectCuratedImage(image.url)">
          <img [src]="image.url" [alt]="image.name">
        </div>
      </div>
    </div>
  </div>

  <!-- Hidden file input -->
  <input #fileInput class="file-upload" type="file" accept="image/*" (change)="processFile(fileInput)">
</div>
